import React from 'react';
import { ProgressCircular } from '@americanexpress/dls-react';

export function Loading() {
  return (
    <section>
      <div className="flex flex-justify-around flex-wrap pad-2-lr pad-3-lr-lg-up">
        <ProgressCircular isDeterminat={false} labelOverrides="Progress Circle" />
      </div>
    </section>
  );
}
